<template>
  <div id="error">
    <NuxtLayout :name="layoutName">
      <div class="errorSection">
        <Alert
          class="my-8 kft-alert--info"
          :title="$t('general.404page.errorAlert.title')"
          :content="$t('general.404page.errorAlert.message', { eventCount })"
        />
        
        <div v-if="!isSubdomain">
          <hr class="my-10" />
          <LazyProductShowcase
            loadingl="loading"
            :products="topEvents"
            :query-id="topEventsQueryID"
            :tags="[]"
            :title="$t('general.404page.eventSuggestions.title')"
            :title-h-class="`h5`"
            :title-level="2"
            algolia-insights-label="Top Events Suggestions - 404 page"
            class="suggestions-product-showcase py-8"
          />
        </div>
      </div>
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'
import { useHomepageAlgolia } from '~/composables/useHomepageAlgolia'
import { eventSectionComposableFactory } from '~/composables/algolia/states'
import { useIsSubdomain } from '~/composables/useSubdomain'
import { NUMBER_OF_EVENTS } from '~/composables/product/constants'
const { error = {} } = defineProps({
  error: Object as () => NuxtError,
})
const { t, locale } = useI18n()
const eventCount = formattedNumberOfEvents(locale.value, NUMBER_OF_EVENTS)
const { algoliaResults } = await useHomepageAlgolia()
const useTopEvents = eventSectionComposableFactory(0)

const { data: topEvents, queryId: topEventsQueryID } =
  useTopEvents(algoliaResults)

const isSubdomain = useIsSubdomain()
const layoutName = computed(() => (isSubdomain?.value ? 'partner' : 'default'))

useHead({
  title: t('general.titles.error'),
})
</script>
